/** Nosto search autocomplete add-to-cart — https://docs.nosto.com/techdocs/implementing-nosto/implement-search/search */
(function () {
  'use strict';

  var CARD_EVT = '@nosto/DynamicCard/loaded';
  var CARD_ATTR = 'data-nosto-dynamic-card-loaded';
  var STORAGE_KEY = 'added_products';
  var FORM_SEL = 'form.js-product-form,form[data-type="add-to-cart-form"],sht-prd-frm.js-sht-product-form';
  var ATC_SEL = '.js-search-atc-btn,.js-product-form-submit-btn[name="add"],form[data-type="add-to-cart-form"] .product-btn-atc';
  var GUARD_SEL = '.js-search-atc-btn,.product-card-atc,.product-card-atc button,.product-card-atc input,.product-card-atc select,sht-qty-inp,.js-quantity-btn,.btn-quick-view';
  var SEARCH_SEL = '[data-inline-predictive-search],.header-predictive-dropdown,.js-predictive-search-results-panel,[data-nosto-element="autocomplete"],.ns-autocomplete,.nosto-autocomplete-wrapper,sht-srch,.js-main-search-result,.search-content';
  var OBSERVE_SEL = '.nosto-autocomplete-wrapper,[data-nosto-element="autocomplete"],.header-predictive-dropdown__inner,.js-main-search-result-grid,.search-content';
  var SCAN_SEL = '.header-predictive-dropdown__inner,.ns-autocomplete-inner,[data-nosto-element="autocomplete"],[class*="nosto"]';
  var WRAP_SEL = '[data-inline-predictive-search],.nosto-autocomplete-wrapper';

  var readyTimer, typeTimer, obsTimer, lastBtn, lastAt = 0;

  function $(el, sel) { return el && el.closest && el.closest(sel); }
  function getWrap(el) { return $(el, WRAP_SEL); }
  function inSearch(el) { return !!$(el, SEARCH_SEL); }
  function inNosto(el) {
    return !!$(el, '[class*="nosto"],[id*="nosto"],[data-nosto-element],.ns-autocomplete,.nosto-autocomplete-wrapper,nosto-dynamic-card');
  }

  function getContext(el) {
    if (!inSearch(el)) return null;
    if ($(el, '[data-inline-predictive-search],.header-predictive-dropdown,.js-predictive-search-results-panel,[data-nosto-element="autocomplete"],.ns-autocomplete,.nosto-autocomplete-wrapper')) return 'autocomplete';
    if ($(el, 'sht-srch,.js-main-search-result,.search-result,.main-search-grid')) return 'serp';
    return 'autocomplete';
  }

  function productId(root) {
    if (!root) return '';
    var id = root.getAttribute('data-product-handle');
    if (id) return id;
    var field = root.querySelector('[name="product-id"]');
    if (field && field.value) return field.value;
    var card = $(root, '[data-product],.search-product-card,.product-card');
    if (card) {
      var m = (card.getAttribute('data-product') || '').match(/(\d+)/);
      if (m) return m[1];
    }
    return '';
  }

  function nostoHit(root) {
    if (!root) return null;
    var pid = productId(root);
    if (!pid) return null;
    var url = root.getAttribute('data-product-url') || '';
    var card = $(root, '[data-product],.search-product-card,.product-card');
    if (!url && card) {
      url = card.getAttribute('data-product-url') || '';
      if (!url) {
        var link = card.querySelector('a[href*="/products/"]');
        if (link) url = link.getAttribute('href') || link.href.split('?')[0];
      }
    }
    if (!url) {
      var wrap = $(root, '[data-nosto-url]');
      if (wrap) url = wrap.getAttribute('data-nosto-url') || '';
    }
    return { productId: String(pid), url: url };
  }

  function formRoot(btn) {
    var id = btn.getAttribute('form');
    if (id) {
      var node = document.getElementById(id);
      if (node && (node.matches('form.js-product-form') || node.matches('sht-prd-frm'))) return node;
    }
    return btn.closest(FORM_SEL);
  }

  function cardReady(card) {
    if (!card) return false;
    var root = card.querySelector(FORM_SEL);
    var id = root && root.querySelector('[name="id"]');
    return !!(id && id.value);
  }

  function isReady(el) {
    if (!el || !inNosto(el)) return true;
    if ($(el, '[' + CARD_ATTR + '="true"]')) return true;
    return cardReady(el.closest('.search-product-card'));
  }

  function markLoaded(root) {
    if (!root || root.nodeType !== 1) return;
    root.setAttribute(CARD_ATTR, 'true');
    var card = root.matches && root.matches('.search-product-card,[data-product]') ? root : root.closest('.search-product-card,[data-product]') || root.querySelector('.search-product-card,[data-product]');
    if (card) card.setAttribute(CARD_ATTR, 'true');
  }

  function upgrade(root) {
    ['sht-prd-frm', 'sht-qty-inp', 'sht-lazy-loader'].forEach(function (tag) {
      root.querySelectorAll(tag).forEach(function (el) { try { customElements.upgrade(el); } catch (e) {} });
    });
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    var cards = root.matches('.search-product-card') ? [root] : root.querySelectorAll('.search-product-card');
    cards.forEach(function (card) {
      if (!inNosto(card) || !cardReady(card)) return;
      markLoaded(card);
      upgrade(card);
    });
  }

  function formData(root) {
    var data = new FormData();
    var seen = new Set();
    root.querySelectorAll('input,select,textarea').forEach(function (field) {
      var key = field.name + ':' + field.type;
      if (!field.name || field.disabled || seen.has(key)) return;
      if (field.type === 'submit' || field.type === 'button') return;
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
      seen.add(key);
      data.append(field.name, field.value);
    });
    if (!data.get('id')) {
      var id = root.querySelector('[name="id"]');
      if (id) { id.disabled = false; data.set('id', id.value); }
    }
    if (!data.get('quantity')) data.set('quantity', '1');
    return data;
  }

  function setError(root, msg) {
    var w = root.querySelector('.js-product-form-error-wrapper');
    var m = root.querySelector('.js-product-form-error-message');
    if (w) w.hidden = !msg;
    if (m && msg) m.textContent = msg;
  }

  function setLoading(btn, on) {
    if (!btn) return;
    var sp = btn.querySelector('.js-product-form-spinner');
    btn.classList.toggle('loading', on);
    if (on) {
      btn.setAttribute('disabled', 'true');
      btn.setAttribute('aria-disabled', 'true');
    } else {
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
    }
    if (sp) sp.classList.toggle('hidden', !on);
  }

  function refreshCart(data, qty) {
    var quantity = parseInt(qty, 10) || parseInt(data && data.quantity, 10) || 1;
    var noti = document.querySelector('sht-cart-noti');
    var drawer = document.querySelector('sht-cart-drwr');
    if (document.body.getAttribute('data-cart-noti-type') === 'cart_noti' && drawer && drawer.renderContents) {
      drawer.renderContents(data);
      return;
    }
    if (noti && noti.renderContents) {
      noti.renderContents(data, true, null, quantity);
      return;
    }
    if (document.body.getAttribute('data-cart-type') === 'drawer' && drawer && drawer.open) drawer.open();
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { response: data } }));
  }

  function addToCart(root, btn, type) {
    if (!root || btn.classList.contains('loading') || !window.routes || !window.routes.cart_add_url) return;
    setError(root, null);
    var data = formData(root);
    if (!data.get('id')) { setError(root, 'Please select a product option.'); return; }

    var pid = productId(root);
    var qty = Math.max(1, parseInt(data.get('quantity') || '1', 10) || 1);
    var hit = nostoHit(root);
    setLoading(btn, true);

    var sections = [];
    var noti = document.querySelector('sht-cart-noti');
    var drawer = document.querySelector('sht-cart-drwr');
    if (noti && noti.getSectionsToRender) sections = sections.concat(noti.getSectionsToRender());
    if (drawer && drawer.getSectionsToRender) sections = sections.concat(drawer.getSectionsToRender());
    if (sections.length) {
      data.append('sections', sections.map(function (s) { return s.id; }).join(','));
      data.append('sections_url', window.location.pathname);
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: data,
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { setError(root, res.description || res.message); return; }
        if (pid && qty > 0) {
          var list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
          var i = list.findIndex(function (x) { return String(x.id) === String(pid); });
          if (i > -1) list[i].quantity += qty;
          else list.unshift({ id: String(pid), quantity: qty });
          localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, 50)));
        }
        if (window.applyActiveProductsFromStorage) window.applyActiveProductsFromStorage();
        if (hit && type && window.nostojs) {
          window.nostojs(function (api) {
            if (api.recordSearchAddToCart) api.recordSearchAddToCart(type, hit);
          });
        }
        refreshCart(res, qty);
      })
      .catch(function () { setError(root, 'Could not add to cart. Please try again.'); })
      .finally(function () { setLoading(btn, false); });
  }

  function handleClick(btn, e) {
    if (!btn || !inSearch(btn)) return;

    var now = Date.now();
    if (btn === lastBtn && now - lastAt < 600) return;
    lastBtn = btn;
    lastAt = now;

    if (e) { e.preventDefault(); e.stopPropagation(); }

    var type = getContext(btn);
    if (!type) return;

    var card = btn.closest('.search-product-card');
    if (card) { scan(card); upgrade(card); }

    if (btn.dataset.sellingPlan === 'true' && window.dialogQuickBuy) {
      window.dialogQuickBuy.checkSellingPlan(btn, true);
      window.dialogQuickBuy.showModal(btn, true);
      return;
    }

    var root = formRoot(btn);
    if (!root || !isReady(btn)) return;
    addToCart(root, btn, type);
  }

  function productUrl(card) {
    var url = card.getAttribute('data-product-url');
    if (url) return url.split('?')[0];
    var link = card.querySelector('a[href*="/products/"]');
    return link ? link.href.split('?')[0] : '';
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('.search-product-card').forEach(function (card) {
      var url = productUrl(card);
      if (!url) return;
      card.setAttribute('data-product-url', url.split('?')[0]);
      var h3 = card.querySelector('h3');
      if (!h3) return;
      var link = h3.matches('a.card__title,a.js-search-product-link') ? h3 : h3.querySelector('a.card__title,a.js-search-product-link');
      if (link) {
        link.classList.add('js-search-product-link');
        if (!link.href || link.getAttribute('href') === '#') link.href = url;
        return;
      }
      var text = h3.textContent.trim();
      if (!text) return;
      var a = document.createElement('a');
      a.href = url;
      a.className = 'card__title card__title--clamp td-none js-search-product-link';
      a.textContent = text;
      h3.textContent = '';
      h3.appendChild(a);
    });
    root.querySelectorAll('[name="id"]').forEach(function (el) { el.disabled = false; });
    upgrade(root);
    if (window.applyActiveProductsFromStorage) window.applyActiveProductsFromStorage();
  }

  function schedule(from) {
    clearTimeout(readyTimer);
    readyTimer = setTimeout(function () {
      var roots = from && from.nodeType === 1
        ? [$(from, OBSERVE_SEL) || from]
        : document.querySelectorAll(OBSERVE_SEL);
      roots.forEach(function (r) { if (r) { scan(r); init(r); } });
    }, 120);
  }

  function onCardLoaded(e) {
    if (!e.target || e.target.nodeType !== 1) return;
    markLoaded(e.target);
    upgrade(e.target);
    schedule(e.target);
  }

  function onInput(e) {
    if (!e.target.matches || !e.target.matches('.header-searchbar__input,[data-nosto-element="search-input"]')) return;
    var wrap = getWrap(e.target);
    if (!wrap) return;
    clearTimeout(typeTimer);
    typeTimer = setTimeout(function () {
      wrap.querySelectorAll(SCAN_SEL).forEach(function (r) { scan(r); schedule(r); });
    }, 450);
  }

  function onAtcDown(e) {
    var btn = e.target.closest(ATC_SEL);
    if (!btn || !inSearch(btn) || e.button !== 0) return;
    document.querySelectorAll(WRAP_SEL).forEach(function (w) { w.dataset.atcInteraction = 'true'; });
    e.stopPropagation();
    handleClick(btn, e);
  }

  function onAtcUp() {
    document.querySelectorAll(WRAP_SEL).forEach(function (w) { delete w.dataset.atcInteraction; });
  }

  function stopNostoNav(e) {
    if (!e.target.closest(GUARD_SEL) || !$(e.target, '.ns-autocomplete-element,[data-nosto-element="product"]')) return;
    e.stopPropagation();
  }

  function observe() {
    var pending;
    var obs = new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        for (var j = 0; j < ms[i].addedNodes.length; j++) {
          var n = ms[i].addedNodes[j];
          if (n.nodeType === 1 && (n.matches('nosto-dynamic-card,.search-product-card,.js-search-atc-btn') || n.querySelector('nosto-dynamic-card,.search-product-card,.js-search-atc-btn'))) {
            pending = pending || n;
            break;
          }
        }
      }
      if (pending) {
        clearTimeout(obsTimer);
        obsTimer = setTimeout(function () { schedule(pending); pending = null; }, 150);
      }
    });
    document.querySelectorAll(OBSERVE_SEL).forEach(function (el) { obs.observe(el, { childList: true, subtree: true }); });
  }

  window.TFSearchAtc = window.TFSearchAtc || {};
  window.TFSearchAtc.handleClick = handleClick;
  window.TFSearchAtc._handleClick = handleClick;
  window.TFSearchAtc._onDynamicCardLoaded = onCardLoaded;
  window.TFSearchAtc._scanAndMarkReadyCards = scan;
  window.TFSearchAtc.DYNAMIC_CARD_LOADED_EVENT = CARD_EVT;
  window.TFSearchResults = { init: init };

  (window.__tfNostoCardQueue || []).forEach(onCardLoaded);
  window.__tfNostoCardQueue = [];
  (window.__tfNostoClickQueue || []).forEach(function (q) { handleClick(q[0], q[1]); });
  window.__tfNostoClickQueue = [];

  document.addEventListener('input', onInput, true);
  document.addEventListener('pointerdown', onAtcDown, false);
  document.addEventListener('pointerup', onAtcUp, true);
  document.addEventListener('pointercancel', onAtcUp, true);
  ['click', 'mousedown', 'pointerdown'].forEach(function (t) { document.addEventListener(t, stopNostoNav, false); });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement) || !f.classList.contains('header-searchbar__form')) return;
    var submitter = e.submitter;
    if (submitter && submitter.closest && submitter.closest('.header-searchbar__submit')) return;
    if (
      submitter &&
      submitter.closest &&
      submitter.closest('.js-search-atc-btn, .js-product-form-submit-btn, .product-card-atc, .search-product-card, form[data-type="add-to-cart-form"]')
    ) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  function boot() { observe(); schedule(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
